<template>
  <v-card style="padding: 8px;">
    <v-progress-linear v-if="getLoadingBar" v-model="getProgressBarValue" striped height="15">
      <span style="font-size:.8em">{{ Math.ceil(getProgressBarValue) }}%</span>
    </v-progress-linear>
    <Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey"
      :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width" :height="height" />
  </v-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { mapGetters, mapActions, mapMutations } from "vuex";
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels);
import moment from 'moment';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => { }
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      query: false,
      show: true,
      chartData: {
        plugins: {
          datalabels: {
            display: true,   // This makes sure the data label is always displayed
            anchor: 'end',
            align: 'top',
            color: 'black',
            font: {
              weight: 'bold',
            }
          },
          formatter: function (value) {
            return value;
          },
        },
        labels: [
          this.moment().subtract(5, 'months').format('YYYY - MM'),
          this.moment().subtract(4, 'months').format('YYYY - MM'),
          this.moment().subtract(3, 'months').format('YYYY - MM'),
          this.moment().subtract(2, 'months').format('YYYY - MM'),
          this.moment().subtract(1, 'months').format('YYYY - MM'),
          this.moment().subtract(0, 'months').format('YYYY - MM'),
        ],
        datasets: [
          {
            position: 'relative',
            label: 'Commission Graph',
            backgroundColor: '#36a2eb50',
            borderColor: '#36a2eb',
            borderWidth: 2,
            borderRadius: 4,
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: 'linear',
              from: 1,
              to: 0,
              loop: true
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters("$_affiliate",
      {
        getBarChartData: "getBarChartData",
        getLoadingBar: "getLoadingBar",
        getProgressBarValue: 'getProgressBarValue'
      })
  },
  async mounted() {
    await this.fetchBarChart();
    this.chartData.datasets[0].data = this.getBarChartData;
  },
  methods: {
    moment,
    ...mapActions("$_affiliate", [
      "fetchBarChart"
    ]),
    ...mapMutations("$_affiliate", [
      "CLEAR_BAR_CHART_PROGRESS",
    ]),
  },
  beforeRouteLeave(to, from, next) {
    this.CLEAR_BAR_CHART_PROGRESS()
    next();
  },
}
</script>